import * as React from 'react';
import { InlineText1 } from '@cian/ui-kit';
import * as styles from './styles.css';

interface IRealtyValuationProps {
  text: string;
  emojiUrl: string;
}

export function Promo({ text, emojiUrl }: IRealtyValuationProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['icon']} style={{ backgroundImage: `url(${emojiUrl})` }} />
      <InlineText1>{text}</InlineText1>
    </div>
  );
}
